function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M18.75 0h-15C1.687 0 .019 1.665.019 3.7L0 33.3C0 35.335 1.669 37 3.731 37H26.25c2.063 0 3.75-1.665 3.75-3.7V11.1L18.75 0zm7.5 33.3H3.75V3.7h13.125v9.25h9.375V33.3z",
  fill: "#000"
});
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M13.008 23l2.567 2.567-6.562 6.562-2.567-2.567z"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 17,
  cy: 21,
  r: 4.5,
  stroke: "#000",
  strokeWidth: 3
});
function SvgCtUploadParsingIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 37,
    viewBox: "0 0 30 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3);
}
export default "data:image/svg+xml,%3csvg width='30' height='37' viewBox='0 0 30 37' fill='none' xmlns='http://www.w3.org/2000/svg'%3e %3cg id='Group 24760'%3e %3cpath id='Vector' d='M18.75 0H3.75C1.6875 0 0.0187504 1.665 0.0187504 3.7L0 33.3C0 35.335 1.66875 37 3.73125 37H26.25C28.3125 37 30 35.335 30 33.3V11.1L18.75 0ZM26.25 33.3H3.75V3.7H16.875V12.95H26.25V33.3Z' fill='black'/%3e %3crect id='Rectangle 11670' x='13.0078' y='23' width='3.62996' height='9.28009' transform='rotate(45 13.0078 23)' fill='black'/%3e %3ccircle id='Ellipse 1258' cx='17' cy='21' r='4.5' stroke='black' stroke-width='3'/%3e %3c/g%3e %3c/svg%3e";
export { SvgCtUploadParsingIcon as ReactComponent };